"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mathSizeToFieldDefaultMode = exports.mathSizeToSpanMode = exports.mathSizeToLatexStylePrefix = exports.MATH_SIZE_FONT = exports.MATH_SIZE_PADDING = exports.getStoredMathLang = exports.getMathLang = exports.getStoredMathSize = exports.getMathSize = exports.MATH_SIZE_LABEL = exports.MATH_SIZES = exports.DEF_LANG = exports.DEF_SIZE = void 0;
exports.DEF_SIZE = 'L';
exports.DEF_LANG = 'latex';
exports.MATH_SIZES = ['L', 'M', 'S'];
exports.MATH_SIZE_LABEL = {
    L: 'Display',
    M: 'Text',
    S: 'Small',
};
const getMathSize = (value) => {
    if (value === 'L' || value === 'M' || value === 'S')
        return value;
    return exports.DEF_SIZE;
};
exports.getMathSize = getMathSize;
const getStoredMathSize = (value) => (value === exports.DEF_SIZE ? undefined : value);
exports.getStoredMathSize = getStoredMathSize;
const getMathLang = (value) => {
    if (value === 'latex' || value === 'asciimath' || value === 'mathml')
        return value;
    return exports.DEF_LANG;
};
exports.getMathLang = getMathLang;
const getStoredMathLang = (value) => (value === exports.DEF_LANG ? undefined : value);
exports.getStoredMathLang = getStoredMathLang;
exports.MATH_SIZE_PADDING = {
    L: '4px 16px',
    M: '2px 12px',
    S: '1px 10px',
};
exports.MATH_SIZE_FONT = {
    L: '1.3em',
    M: '1.3em',
    S: '1.15em',
};
const mathSizeToLatexStylePrefix = (size) => {
    if (size === 'M')
        return '\\scriptstyle ';
    if (size === 'S')
        return '\\scriptscriptstyle ';
    return '';
};
exports.mathSizeToLatexStylePrefix = mathSizeToLatexStylePrefix;
const mathSizeToSpanMode = (size) => {
    if (size === 'L')
        return 'displaystyle';
    return 'textstyle';
};
exports.mathSizeToSpanMode = mathSizeToSpanMode;
const mathSizeToFieldDefaultMode = (size) => {
    if (size === 'L')
        return 'math';
    return 'inline-math';
};
exports.mathSizeToFieldDefaultMode = mathSizeToFieldDefaultMode;
